import React from "react";
import classes from "./ConfirmationModal.module.css";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { urls } from "../../../Routes/Urls";
import Modal, { ModalBody } from "../../../Components/Modal/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import PrimaryButton from "../../../Components/Buttons/PrimaryButton/PrimaryButton";

const successIcon = "/Assets/Icons/successIcon.svg" // You may want to use a different icon

const ConfirmationModal = ({ email, onClose }) => {
  const history = useHistory()
  return (
    <Modal onClose={onClose}>
      <ModalBody>
        <div className={classes.modal}>
          <div className={classes.modalContent}>
            <div className={classes.iconContainer}>
                <div className={classes.successIcon}>
                <FontAwesomeIcon className={classes.icon} icon={faCheck} />
                </div>
            </div>
            <h2 className={classes.title}>Password Created Successfully</h2>
            <p className={classes.message}>
              Your password has been successfully created.
              <br />
              You can now log in to access your account and explore our new website.
            </p>
            <div className={classes.actions}>
              <PrimaryButton 
                className={classes.loginButton} 
                onClick={() => history.push(urls.LOGIN)}
              >
                Go to Login
              </PrimaryButton>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ConfirmationModal;